import React from "react";
import { useParams } from "react-router-dom";
import MeetingFormNew from "../../../components/adm/meeting/meetingFormNew";
import Layout from "../../../components/layouts/verticalLayout";

/**
 * Página para crear/editar sesiones de formación
 * Usa el componente MeetingFormNew optimizado con interfaz moderna
 */
const MeetingFormPage = () => {
  const { uuid } = useParams();

  return <Layout body={<MeetingFormNew uuid={uuid} />} />;
};

export default MeetingFormPage;
